import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import Button from './Button';
import UserInfo from './UserInfo';
import LinkifyText from './LinkifyText';

const PhysicianStatusModalBody = ({
  physicianName,
  avatarSrc,
  avatarInitials,
  statusMessage,
  note,
  closeButtonLabel,
  clickHandler,
  className,
}) => {
  const cn = useClassNames(() => ['flex', 'flex-col', 'max-h-full', className], [className]);
  return (
    <div data-component="PhysicianStatusModalBody" className={cn}>
      <UserInfo
        avatarSrc={avatarSrc}
        avatarInitials={avatarInitials}
        avatarSize="16"
        title={physicianName}
        subtitle={note}
        className="flex-none font-semibold"
      />
      <LinkifyText>
        <p className="mt-6 mb-8 overflow-auto whitespace-pre-line">{statusMessage}</p>
      </LinkifyText>
      <Button onClick={clickHandler} className="flex-none w-full">
        {closeButtonLabel}
      </Button>
    </div>
  );
};

PhysicianStatusModalBody.defaultProps = {
  avatarSrc: null,
  className: '',
};

PhysicianStatusModalBody.propTypes = {
  physicianName: PropTypes.string.isRequired,
  avatarSrc: PropTypes.string,
  avatarInitials: PropTypes.string.isRequired,
  note: PropTypes.string.isRequired,
  statusMessage: PropTypes.string.isRequired,
  closeButtonLabel: PropTypes.string.isRequired,
  clickHandler: PropTypes.func.isRequired,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default PhysicianStatusModalBody;
